import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const MusiqueRedirect = () => {
    const { musiqueId } = useParams();  // Utilisez useParams pour récupérer le paramètre
    const navigate = useNavigate();

    useEffect(() => {
        const musiques = {
            musique01: 'https://www.youtube.com/watch?v=oqxN_cFnDhQ',
            musique02: 'https://www.youtube.com/watch?v=oY2Cy6Kmxgg',
            musique03: 'https://www.youtube.com/watch?v=dbxl59wDvaM',
            musique04: 'https://www.youtube.com/watch?v=1zlIPDbpX0I',
            musique05: 'https://www.youtube.com/watch?v=S010hhJw3bY',
            musique06: 'https://www.youtube.com/watch?v=-Kbx2bXZmpc',
            musique07: 'https://www.youtube.com/watch?v=Bm5f_glnQ5M',
            musique08: 'https://www.youtube.com/watch?v=fqh7N_4FZDw',
            musique09: 'https://www.youtube.com/watch?v=QIoCncDAgH4',
            musique10: 'https://www.youtube.com/watch?v=SiM00IsAMj0',
            musique11: 'https://www.youtube.com/watch?v=qlpu3AgiHEI',
        };

        // Si une musique correspond, on redirige vers l'URL de YouTube
        // (replace : le bouton Retour de YouTube ne relance pas la redirection)
        if (musiques[musiqueId]) {
            window.location.replace(musiques[musiqueId]);
        } else {
            navigate('/404', { replace: true }); // Si rien, erreur 404
        }
    }, [musiqueId, navigate]);

    return null;
};

export default MusiqueRedirect;
